import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const FormWrapper = styled.div`
  padding: 0;
  width: auto;
  height: auto;
  background: transparent;
  border: none;
  margin-bottom: 28px;
  position: relative;
  .inputPhone {
    width: 100%;
    height: 48px;
    background-color: #ffffff;
    font-size: 14px;
    padding: 15px 20px;
    color: ${colors.black1};
    border: 1px solid ${colors.border3};
    border-radius: 5px;
    &::placeholder {
      font-size: 14px;
      font-style: italic;
      color: ${colors.text3};
      @media (max-width: 575px) {
        font-size: 13px;
      }
    }
    &:focus {
      border-color: ${colors.blue2};
    }
    @media (max-width: 575px) {
      height: 40px;
    }
  }
`;

export const Label = styled.label`
  font-size: 15px;
  color: ${colors.text1};
  font-weight: 500;
  @media (max-width: 575px) {
    font-size: 14px;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  background-color: #ffffff;
  font-size: 14px;
  padding: 15px 20px;
  color: ${colors.black1};
  border: 1px solid ${colors.border3};
  border-radius: 5px;
  &::placeholder {
    font-size: 14px;
    font-style: italic;
    color: ${colors.text3};
    @media (max-width: 575px) {
      font-size: 13px;
    }
  }
  &:focus {
    border-color: ${colors.blue2};
  }
  @media (max-width: 575px) {
    height: 40px;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  background-color: #ffffff;
  font-size: 14px;
  padding: 15px 20px;
  color: ${colors.black1};
  border: 1px solid ${colors.border3};
  border-radius: 5px;
  &::placeholder {
    font-size: 14px;
    font-style: italic;
    color: ${colors.text3};
    @media (max-width: 575px) {
      font-size: 13px;
    }
  }
  &:focus {
    border-color: ${colors.blue2};
  }
  @media (max-width: 575px) {
    height: 40px;
  }
`;

export const Error = styled.span`
  color: ${colors.red};
  font-weight: 300;
  position: absolute;
  bottom: -20px;
  left: 0;
`;
